<template>
  <div
    id="leader-board-wrapper-hld"
    class="leader-board-wrapper-hld"
    style="background-color: #f1f3f4; min-height: 100%"
    @click="onClickHandler"
  >
    <section id="sectionId">
      <v-tabs v-model="tab" class="leader-content" style="margin-top: 18px">
        <div
          class="page-head-text mt-4 mb-0 mb-md-4 px-3 px-md-0 d-flex justify-content-between align-items-center flex-column flex-md-row"
          style="width: 100%"
        >
          <v-tab
            v-if="groupsTab && groupsTabInModal"
            v-show="selectedGroupId"
            class="tab-selected-group pl-0"
            href="#groupDetails"
            @click="hideGroup"
          >
            <h1
              class="page-head head-text-wrap text-uppercase d-flex justify-content-start align-items-center mb-md-0"
              style="color: #333"
            >
              <span
                ><v-btn depressed fab small color="rgba(0,0,0,0)">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn></span
              >
              {{ selectedGroupName }}
            </h1>
          </v-tab>
          <h1
            v-show="!selectedGroupId"
            class="page-head head-text-wrap text-uppercase mb-md-0"
            style="color: #333"
          >
            {{ headerText }}
          </h1>

          <div v-show="tabCount > 1 && !selectedGroupId" class="tab-wrap">
            <v-tab
              v-if="usersTab && usersTabInModal"
              tabindex="1"
              href="#users"
              data-analytics
              data-page-name="/leaderboard"
              data-action="click"
              data-action-type="tab"
              data-action-label="ViewedLeaderboardPage"
            >
              {{ usersTabLabel }} ({{ leaderboardLeaders.length }})
            </v-tab>
            <v-tab
              v-if="groupsTab && groupsTabInModal"
              tabindex="2"
              href="#groups"
              data-analytics
              data-page-name="/leaderboard"
              data-action="click"
              data-action-type="tab"
              data-action-label="ViewedLeaderboardGroupPage"
            >
              {{ groupsTabLabel }} ({{ leaderboardGroups.length }})
            </v-tab>
            <v-tab
              v-if="myScorecardTab && myScorecardTabInModal"
              tabindex="3"
              href="#myScorecard"
              data-analytics
              data-page-name="/leaderboard"
              data-action="click"
              data-action-type="tab"
              data-action-label="ViewedLeaderboardMyScorecard"
            >
              {{ myScorecardTabLabel }} ({{ myActionScores.length }})
            </v-tab>
          </div>
          <div class="mb-0 screen-size-wrap">
            <v-dialog v-model="dialog" width="650">
              <template v-slot:activator="{ on, attrs }">
                <a
                  tabindex="4"
                  href="javascript: void(0);"
                  class="mr-md-5 faq-leaderboard-button"
                  v-bind="attrs"
                  v-on="on"
                  ><span class="d-none d-md-inline lea_faq">Leaderboard</span>
                  FAQ</a
                >
              </template>

              <v-card>
                <div class="p-3">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <h3 class="dialog-head">FAQs</h3>
                    <v-btn
                      class="mb-3"
                      color="transparent"
                      depressed
                      fab
                      dark
                      small
                      @click="dialog = false"
                    >
                      <v-icon large color="#737373"> mdi-close </v-icon>
                    </v-btn>
                  </div>
                  <div class="expansion-pannel-wrap lead_faq_popup">
                    <v-expansion-panels popout class="p-0">
                      <v-expansion-panel class="mb-4" style="max-width: 100%">
                        <v-expansion-panel-header
                          ><h4 class="expansion-header">
                            How are the points calculated for the Leaderboard?
                          </h4></v-expansion-panel-header
                        >
                        <v-expansion-panel-content>
                          <p class="expansion-description">
                            You can earn points for participating in the
                            activities such as asking a Question, Participating
                            in a Poll, Visiting an expo booth, and much more.
                          </p>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                      <v-expansion-panel class="mb-4" style="max-width: 100%">
                        <v-expansion-panel-header
                          ><h4 class="expansion-header">
                            How can I score points?
                          </h4></v-expansion-panel-header
                        >
                        <v-expansion-panel-content>
                          <p class="expansion-description">
                            “My Scorecard” lists all the activities with points
                            earned and additional activities which can help you
                            earn more points.
                          </p>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                      <v-expansion-panel class="mb-4" style="max-width: 100%">
                        <v-expansion-panel-header
                          ><h4 class="expansion-header">
                            How to see other players' levels and profiles?
                          </h4></v-expansion-panel-header
                        >
                        <v-expansion-panel-content>
                          <p class="expansion-description">
                            The leaderboard tab gives you the full list of top
                            scorers and your own score in the event. The more
                            you engage, the more you win!
                          </p>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                      <v-expansion-panel class="mb-4" style="max-width: 100%">
                        <v-expansion-panel-header
                          ><h4 class="expansion-header">
                            What about Rewards and Prizes?
                          </h4></v-expansion-panel-header
                        >
                        <v-expansion-panel-content>
                          <p class="expansion-description">
                            Visit booths, attend webinars, chat with booth reps,
                            explore materials and engaging with show elements
                            will earn you points. Each day, the top 1/3 of point
                            earners will be entered into a drawing to win one of
                            two prize packages. The prizes will be awarded at
                            the end of the live session each day. Good luck and
                            have fun as you explore and earn!
                          </p>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

                      <v-expansion-panel class="mb-4" style="max-width: 100%">
                        <v-expansion-panel-header
                          ><h4 class="expansion-header">
                            How Leaderboard Points are assigned?
                          </h4></v-expansion-panel-header
                        >
                        <v-expansion-panel-content>
                          <p class="expansion-description">
                            The Leaderboard points are allocated against
                            specific activities you perform by your event
                            planner. Some events also have additional gaming
                            activities to earn points. “My Scorecard” gives you
                            an overall view of both event-level activities and
                            game-level activities.
                          </p>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </div>
              </v-card>
            </v-dialog>
            <v-btn
              v-show="isMaximized && !isModal && false"
              @click="isMaximized = !isMaximized"
              depressed
              fab
              dark
              small
              color="#ffffff"
              tabindex="5"
              class="d-mob-none"
            >
              <span
                ><img src="../assets/Images/leaderboard/minimize.svg"
              /></span>
            </v-btn>
            <v-btn
              v-show="!isMaximized && !isModal && false"
              @click="isMaximized = !isMaximized"
              depressed
              fab
              dark
              small
              color="#ffffff"
              class="d-mob-none"
            >
              <span
                ><img src="../assets/Images/leaderboard/maximize.svg"
              /></span>
            </v-btn>
          </div>
        </div>

        <v-tab-item v-if="groupsTab && groupsTabInModal" value="groupDetails">
          <div class="leader-board-rank-list-hld">
            <div class="leader-board-userlist px-3 px-md-0">
              <v-list
                subheader
                rounded
                two-line
                color="rgba(255,255,255,0)"
                class="d-flex align-items-center px-mob-0"
              >
                <v-list-item
                  class="justify-content-between align-items-end px-mob-0"
                >
                  <div class="leader-board-user-search">
                    <v-text-field
                      v-model="groupUserSearchText"
                      solo
                      label="Search users..."
                      tabindex="6"
                    ></v-text-field>
                  </div>
                  <div class="leaderboard-user-list-top pr-md-4">
                    <!--<p>Percentage</p>-->
                    <p class="ml-4">
                      Points <span class="d-none d-md-inline">Earned</span>
                    </p>
                  </div>
                </v-list-item>
              </v-list>
              <v-card
                v-for="member in leaderboardTopGroupLeaders"
                :key="member.UserID"
                class="mx-md-4 mb-md-5 mb-2"
              >
                <v-list
                  subheader
                  rounded
                  two-line
                  class="d-flex align-items-center py-3"
                >
                  <v-list-item>
                    <div
                      class="list-left d-flex justify-content-start align-items-center"
                    >
                      <div class="list-order">
                        <p>{{ member.Rank }}</p>
                      </div>
                      <v-list-item-avatar
                        v-if="member.UserImagePath"
                        class="m-0"
                        height="60px"
                        width="60px"
                      >
                        <v-img
                          :src="member.UserImagePath"
                          @error="member.UserImagePath = ''"
                        ></v-img>
                      </v-list-item-avatar>
                      <v-list-item-avatar
                        v-else
                        class="m-0 no-image"
                        height="60px"
                        width="60px"
                      >
                        <span>{{ member.NameInitial }}</span>
                      </v-list-item-avatar>
                      <v-list-item-content class="ml-4">
                        <v-list-item-title>{{
                          member.UserName
                        }}</v-list-item-title>
                        <v-list-item-subtitle>
                          <p>
                            {{ (member.UserDesignation, member.UserCompany) }}
                          </p>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </div>
                    <div
                      class="list-right d-flex justify-content-between align-items-center"
                    >
                      <div class="progress-wrp m-0">
                        <!--<v-progress-linear
                        :value="member.ScorePercent"
                        background-color="#e5eaeb"
                        color="#4fc0cb"
                        height="10"
                        rounded="true"
                      ></v-progress-linear>
                      <span class="progress-value"
                        >{{ member.ScorePercent }}%</span
                      >-->
                      </div>
                      <v-btn
                        depressed
                        color="#f0f6f7"
                        rounded
                        large
                        min-width="120px"
                        ><b>{{ member.TotalScore }}</b></v-btn
                      >
                    </div>
                  </v-list-item>
                </v-list>
              </v-card>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item v-if="usersTab && usersTabInModal" value="users">
          <div class="leader-board-rank-list-hld">
            <ul
              v-if="
                usersTabTop3 &&
                usersTabTop3InModal &&
                leaderboardLeaders.length > 2
              "
              style="margin-bottom: 1px"
            >
              <li
                v-for="(item, index) in leaderboardTop3Leaders"
                :key="item.UserID"
                :class="index == 1 ? 'topers-top' : ''"
              >
                <v-card>
                  <div class="top-ranker-image-wrap">
                    <div v-if="item.UserImagePath" class="top-ranker-image-hld">
                      <img
                        :src="item.UserImagePath"
                        @error="item.UserImagePath = ''"
                      />
                    </div>
                    <div v-else class="top-ranker-image-hld no-image">
                      <span>{{ item.NameInitial }}</span>
                    </div>
                    <span class="top-rank">
                      <img
                        v-if="item.Rank == 1"
                        src="../assets/Images/leaderboard/rank-1.svg"
                      />
                      <img
                        v-if="item.Rank == 2"
                        src="../assets/Images/leaderboard/rank-2.svg"
                      />
                      <img
                        v-if="item.Rank == 3"
                        src="../assets/Images/leaderboard/rank-3.svg"
                      />
                    </span>
                    <div v-if="item.Rank == 1" class="rank-confetti">
                      <img src="../assets/Images/leaderboard/confetti.svg" />
                    </div>
                  </div>
                  <div class="rank-details">
                    <h4 class="participant">{{ item.UserName }}</h4>
                    <p class="mb-0">{{ item.UserDesignation }}</p>
                    <p>{{ item.UserCompany }}</p>
                    <!--<div class="progress-wrp">
                    <v-progress-linear
                      :value="item.ScorePercent"
                      background-color="#e5eaeb"
                      color="#4fc0cb"
                      height="10"
                      rounded="true"
                    ></v-progress-linear>
                    <span class="progress-value">{{ item.ScorePercent }}%</span>
                  </div>-->
                    <v-btn depressed color="#f0f6f7" rounded large class="mt-4">
                      <b>{{ item.TotalScore }}{{ " Points" }}</b>
                    </v-btn>
                  </div>
                </v-card>
              </li>
            </ul>
            <div class="leader-board-userlist">
              <v-list
                subheader
                rounded
                two-line
                color="rgba(255,255,255,0)"
                class="d-flex align-items-center px-mob-0"
              >
                <v-list-item
                  class="justify-content-between align-items-end px-mob-0"
                >
                  <div class="leader-board-user-search">
                    <v-text-field
                      v-model="userSearchText"
                      solo
                      label="Search users..."
                    ></v-text-field>
                  </div>
                  <div class="leaderboard-user-list-top pr-md-4">
                    <!--<p>Percentage</p>-->
                    <p class="ml-4">
                      Points <span class="d-none d--md-inline">Earned</span>
                    </p>
                  </div>
                </v-list-item>
              </v-list>
              <v-card
                v-for="member in leaderboardTopLeaders"
                :key="member.UserID"
                class="mx-4 mb-5"
              >
                <v-list
                  subheader
                  rounded
                  two-line
                  class="d-flex align-items-center py-3 rank_inner-wrap"
                >
                  <v-list-item>
                    <div
                      class="list-left d-flex justify-content-start align-items-center"
                    >
                      <div class="list-order">
                        <p>{{ member.Rank }}</p>
                      </div>
                      <v-list-item-avatar
                        v-if="member.UserImagePath"
                        class="m-0"
                        height="60px"
                        width="60px"
                      >
                        <v-img
                          :src="member.UserImagePath"
                          @error="member.UserImagePath = ''"
                        ></v-img>
                      </v-list-item-avatar>
                      <v-list-item-avatar
                        v-else
                        class="m-0 no-image"
                        height="60px"
                        width="60px"
                      >
                        <span>{{ member.NameInitial }}</span>
                      </v-list-item-avatar>
                      <v-list-item-content class="ml-4">
                        <v-list-item-title>{{
                          member.UserName
                        }}</v-list-item-title>
                        <v-list-item-subtitle>
                          <p>
                            {{ (member.UserDesignation, member.UserCompany) }}
                          </p>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </div>
                    <div
                      class="list-right d-flex justify-content-between align-items-center"
                    >
                      <div class="progress-wrp m-0">
                        <!--<v-progress-linear
                        :value="member.ScorePercent"
                        background-color="#e5eaeb"
                        color="#4fc0cb"
                        height="10"
                        rounded="true"
                      ></v-progress-linear>
                      <span class="progress-value"
                        >{{ member.ScorePercent }}%</span
                      >-->
                      </div>
                      <v-btn
                        depressed
                        color="#f0f6f7"
                        rounded
                        large
                        min-width="120px"
                        ><b>{{ member.TotalScore }}</b></v-btn
                      >
                    </div>
                  </v-list-item>
                </v-list>
              </v-card>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item v-if="groupsTab && groupsTabInModal" value="groups">
          <div class="leader-board-userlist group-list">
            <v-list
              subheader
              rounded
              two-line
              class="d-flex align-items-center py-3 px-mob-0"
            >
              <v-list-item
                class="justify-content-between align-items-end px-mob-0"
              >
                <div class="leader-board-user-search">
                  <v-text-field
                    v-model="groupSearchText"
                    solo
                    label="Search groups... "
                    >{{ tab }}</v-text-field
                  >
                </div>
                <div class="leaderboard-user-list-top">
                  <!--<p>Percentage</p>-->
                  <p class="ml-4">
                    Points <span class="d-none d--md-inline">Earned</span>
                  </p>
                </div>
              </v-list-item>
            </v-list>
            <!--{{ leaderboardGroups }}-->
            <v-card
              v-for="(item, index) in leaderboardTopGroups"
              :key="item.GroupID"
              :class="
                index == 0
                  ? 'mx-4 mb-md-5 mb-2 first-card'
                  : 'mx-4 mb-md-5 mb-2'
              "
            >
              <v-list
                subheader
                rounded
                two-line
                class="d-flex align-items-center py-3 px-mob-0"
              >
                <v-list-item>
                  <div
                    class="list-left d-flex justify-content-start align-items-center"
                  >
                    <div class="list-order">
                      <div class="top-order">
                        <p>
                          <img
                            v-if="item.Rank == 1"
                            src="../assets/Images/leaderboard/rank-1.svg"
                          />
                          <img
                            v-else-if="item.Rank == 2"
                            src="../assets/Images/leaderboard/rank-2.svg"
                          />
                          <img
                            v-else-if="item.Rank == 3"
                            src="../assets/Images/leaderboard/rank-3.svg"
                          />
                          <span v-else>{{ item.Rank }}</span>
                        </p>
                      </div>
                    </div>
                    <!--<v-list-item-avatar class="m-0" height="60px" width="60px">
                    <v-img
                      src="../assets/Images/leaderboard/profile-3.jpg"
                    ></v-img>
                  </v-list-item-avatar>-->

                    <v-list-item-content class="ml-4">
                      <v-list-item-title>{{
                        item.GroupName
                      }}</v-list-item-title>
                      <v-list-item-subtitle>
                        {{
                          item.Participances.length +
                          (item.Participances.length > 1
                            ? " attendees"
                            : " attendee")
                        }}
                        participated
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </div>
                  <div
                    class="list-right d-flex justify-content-between align-items-center"
                  >
                    <div class="progress-wrp m-0">
                      <!--<v-progress-linear
                      :value="item.ScorePercent"
                      background-color="#e5eaeb"
                      color="#4fc0cb"
                      height="10"
                      rounded="true"
                    ></v-progress-linear>
                    <span class="progress-value">
                      {{ item.ScorePercent }}%
                    </span>-->
                    </div>
                    <div class="aero-btn">
                      <v-btn
                        depressed
                        color="#f0f6f7"
                        rounded
                        large
                        min-width="120px"
                      >
                        <b>{{ item.TotalScore }}</b>
                      </v-btn>
                      <v-btn
                        class="ml-md-10 ml-2 l_group_arrow"
                        fab
                        dark
                        small
                        color="#f0f6f7"
                        @click="showGroup(item.GroupID, item.GroupName)"
                      >
                        <v-icon color="#333">mdi-arrow-right</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-list-item>
              </v-list>
            </v-card>
          </div>
        </v-tab-item>
        <v-tab-item
          v-if="myScorecardTab && myScorecardTabInModal"
          value="myScorecard"
        >
          <v-card
            v-if="myTotalScore && myTotalScoreInModal"
            color="rgba(255,255,255,0)"
            class="my-achieved-points mx-1 my-4"
            rounded="15"
          >
            <v-img
              src="../assets/Images/leaderboard/image_2021_06_18T06_28_27_366Z.png"
            >
            </v-img>
            <div class="achieved-points-inner">
              <h1>{{ myLeaderboard ? myLeaderboard.TotalScore : 0 }}</h1>
              <h4>POINTS</h4>
              <div class="progress-wrp mt-5">
                <!--<v-progress-linear
                :value="myLeaderboard ? myLeaderboard.ScorePercent : 0"
                background-color="#ffffff"
                color="#4fc0cb"
                height="15"
                rounded="true"
              ></v-progress-linear>
              <span class="progress-value">
                {{ myLeaderboard ? myLeaderboard.ScorePercent : 0 }}%
              </span>-->
              </div>
            </div>
          </v-card>
          <div class="total-point-display d-flex d-md-none">
            <h3>{{ myLeaderboard.TotalScore }}</h3>
          </div>
          <div class="point-breakup-table-hld mx-1">
            <v-row>
              <v-col cols="12" md="12">
                <v-list color="rgba(255,255,255,0)" subheader>
                  <v-list-item>
                    <v-list-item-content style="min-width: 50%">
                      <v-list-item-title>ACTIVITIES</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content
                      v-if="!isMobileView"
                      style="text-align: right"
                    >
                      <v-list-item-title>POINT VALUE</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content
                      v-if="!isMobileView"
                      style="text-align: right"
                    >
                      <v-list-item-title>MY ACTIVITY COUNT</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content style="text-align: right">
                      <v-list-item-title>POINTS EARNED</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <!--<div>{{ myActionScores }}</div>-->
                <v-card class="point-table mb-4">
                  <v-list
                    subheader
                    v-for="item in leaderboardActions"
                    :key="item.ActionTypeCode"
                  >
                    <v-list-item>
                      <v-list-item-content style="min-width: 50%">
                        <v-list-item-title>
                          <b>{{ item.DisplayLabel }}</b>
                          <!--<b>-[{{ item.ActionTypeCode }}]</b>-->
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-content
                        v-if="!isMobileView"
                        style="text-align: right"
                      >
                        <v-list-item-title>
                          <b v-if="!item.CollectionPath">{{
                            item.ActionScore
                          }}</b>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-content
                        v-if="!isMobileView"
                        style="text-align: right"
                      >
                        <v-list-item-title>
                          <b v-if="!item.CollectionPath">{{ item.Count }}</b>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-content style="text-align: right">
                        <v-list-item-title>
                          <b>{{ item.TotalScore }}</b>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="m-0"></v-divider>
                  </v-list>
                </v-card>
              </v-col>
              <!--<v-col cols="12" md="6">
              <v-list subheader color="rgba(255,255,255,0)">
                <v-list-item>
                  <v-list-item-content style="min-width: 50%">
                    <v-list-item-title>ACTIVITIES</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content style="text-align: right">
                    <v-list-item-title>POINT</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content style="text-align: right">
                    <v-list-item-title>COUNT</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content style="text-align: right">
                    <v-list-item-title>EARNED</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-card class="point-table mb-4">
                <v-list
                  subheader
                  v-for="item in myActionTopScores2"
                  :key="item.ActionTypeCode"
                >
                  <v-list-item>
                    <v-list-item-content style="min-width: 50%">
                      <v-list-item-title>
                        <b>{{ item.DisplayLabel }}</b>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content style="text-align: right">
                      <v-list-item-title>
                        <b>{{ item.ActionScore }}</b>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content style="text-align: right">
                      <v-list-item-title>
                        <b>{{ item.Count }}</b>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content style="text-align: right">
                      <v-list-item-title>
                        <b>{{ item.TotalScore }}</b>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="m-0"></v-divider>
                </v-list>
              </v-card>
            </v-col>-->
            </v-row>
          </div>
        </v-tab-item>
      </v-tabs>

      <!-- <div class="leader-board-blank-page">
      <v-img max-width="160" max-height="111" src="../assets/Images/icons/leaderboard-icon-web.svg"></v-img>
      <h4>Unbelievable! no one has scored yet. Participate and be the first to score &amp; rank</h4>
    </div> -->
      <v-card v-if="myLeaderboard && !isModal" class="my-rank-list">
        <v-list
          subheader
          rounded
          two-line
          class="d-flex align-items-center py-md-3 py-5"
        >
          <v-list-item class="my-rank-list_inner_w">
            <div
              class="list-left d-flex justify-content-start align-items-center"
            >
              <div class="list-order">
                <label>My Rank</label>
                <p>{{ myLeaderboard.Rank }}</p>
              </div>
              <v-list-item-avatar
                v-if="myLeaderboard.UserImagePath"
                class="m-0 mt-5"
                height="60px"
                width="60px"
              >
                <v-img
                  :src="myLeaderboard.UserImagePath"
                  @error="myLeaderboard.UserImagePath = ''"
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-avatar
                v-else
                class="m-0 mt-5 no-image"
                height="60px"
                width="60px"
              >
                <span>{{ myLeaderboard.NameInitial }}</span>
              </v-list-item-avatar>

              <v-list-item-content
                class="ml-4 content-my-list p-0"
                style="height: 100%"
              >
                <label class="mb-2">My Name</label>
                <v-list-item-title>
                  {{ myLeaderboard.UserName }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <p class="m-0">
                    {{
                      (myLeaderboard.UserDesignation, myLeaderboard.UserCompany)
                    }}
                  </p>
                </v-list-item-subtitle>
              </v-list-item-content>
            </div>
            <div
              class="list-right d-flex justify-content-between align-items-center"
            >
              <div class="progress-wrp m-0">
                <!--<v-progress-linear
                      :value="myLeaderboard.ScorePercent"
                      background-color="#e5eaeb"
                      color="#4fc0cb"
                      height="10"
                      rounded="true"
                    ></v-progress-linear>
                    <span class="progress-value">
                      {{ myLeaderboard.ScorePercent }}%
                    </span>-->
              </div>
              <div
                class="my-points d-flex flex-column align-items-center my-rank-list_point_w"
              >
                <label>My Points</label>
                <v-btn
                  depressed
                  color="#f0f6f7"
                  rounded
                  large
                  min-width="120px"
                >
                  <b>{{ myLeaderboard.TotalScore }}</b>
                </v-btn>
              </div>
            </div>
          </v-list-item>
        </v-list>
      </v-card>
    </section>
  </div>
</template>

<script>
import db from "../components/firebaseInit";
import jQuery from "jquery";
let $ = jQuery;
//import axios from "axios";
//import APIs from "../components/APIInit";
import common from "@/common";
import { bus } from "@/main";
import analytics from "@/components/Analytics";

let vm;
let leaderboardTimer;
export default {
  components: {},
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    usersTabInModal: {
      type: Boolean,
      default: true,
    },
    usersTabTop3InModal: {
      type: Boolean,
      default: true,
    },
    groupsTabInModal: {
      type: Boolean,
      default: true,
    },
    myScorecardTabInModal: {
      type: Boolean,
      default: true,
    },
    myTotalScoreInModal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      headerText: "Leaderboard",
      isMaximized: false,
      leaderboardLoaded: false,
      clientId: "",
      eventId: "",
      event_collectionName: "",
      uid: "",
      email: "",
      firstName: "",
      lastName: "",
      fullName: "",
      company: "",
      country: "",
      dialog: false,
      designation: "",
      profilePictureURL: "",
      settingsLoaded: false,
      hasSettings: false,
      tab: "",
      tabCount: 0,
      usersTabLabel: "My Achivements",
      groupsTabLabel: "Groups",
      myScorecardTabLabel: "My Scorecard",
      usersTab: false,
      usersTabTop3: false,
      groupsTab: false,
      myScorecardTab: false,
      myTotalScore: false,
      leaderboardActions: [],
      myActionScores: [],
      leaderboardBadges: [],
      //leaderboardLeaderIDs: [],
      leaderboardLeaders: [],
      leaderboardGroups: [],
      myLeaderboardScore: 0,
      revisionNo: 0,
      userSearchText: "",
      groupSearchText: "",
      groupUserSearchText: "",
      selectedGroupId: "",
      selectedGroupName: "",
      isMobileView: false,
    };
  },
  //beforeRouteLeave(to, from, next) {
  //  if (vm.allowLeavePage) {
  //    vm.allowLeavePage = false;
  //    $("#app").removeClass("player");
  //    $("body").removeClass("player");
  //    next(true);
  //  } else {
  //    if (vm.callStarted) {
  //      //let fullPath = "http://google.com";
  //      let fullPath = location.origin + to.fullPath;
  //      window.open(fullPath, "_blank");
  //    } else {
  //      $("#app").removeClass("player");
  //      $("body").removeClass("player");
  //      next(true);
  //      //vm.redirectToPath = to.fullPath;
  //      //$("#popupPageLeaveConfirm").modal("show");
  //    }
  //    //next(false);
  //  }
  //},
  computed: {
    leaderboardTop3Leaders() {
      var result = [];
      //if (vm.leaderboardLeaders.length > 2) {
      //  result = vm.leaderboardLeaders.slice(0, 3);
      //  result.sort(function (a, b) {
      //    let aName = parseInt(a.Rank);
      //    let bName = parseInt(b.Rank);
      //    if (aName < bName) {
      //      return -1;
      //    }
      //    if (aName > bName) {
      //      return 1;
      //    }
      //    return 0;
      //  });
      //}
      if (vm.leaderboardLeaders.length > 2) {
        result.push(vm.leaderboardLeaders[1]);
        result.push(vm.leaderboardLeaders[0]);
        result.push(vm.leaderboardLeaders[2]);
      }
      return result;
    },
    leaderboardTopLeaders() {
      //alert(vm.userSearchText);
      var result = [];
      if (vm.leaderboardLeaders.length < 3) {
        result = vm.leaderboardLeaders;
      } else {
        if (vm.usersTabTop3 && vm.usersTabTop3InModal) {
          result = vm.leaderboardLeaders.slice(3, vm.leaderboardLeaders.length);
        } else {
          result = vm.leaderboardLeaders;
        }
      }
      if (vm.userSearchText) {
        vm.userSearchText = vm.userSearchText.trim().toLowerCase();
        result = result.filter(function (item) {
          return item.UserName.toLowerCase().includes(vm.userSearchText);
        });
      }
      return result;
    },
    myLeaderboard() {
      var result = null;
      var results = vm.leaderboardLeaders.filter(function (item) {
        return item.UserID == vm.uid;
      });
      if (results.length > 0) {
        result = results[0];
      }
      if (result) {
        vm.myLeaderboardScore = result.TotalScore;
      }
      return result;
    },
    leaderboardTopGroups() {
      var result = vm.leaderboardGroups;
      if (vm.groupSearchText) {
        vm.groupSearchText = vm.groupSearchText.trim().toLowerCase();
        result = result.filter(function (item) {
          return item.GroupName.toLowerCase().includes(vm.groupSearchText);
        });
      }
      return result;
    },
    myActionTopScores() {
      var result = [];
      var index = 0;
      vm.leaderboardActions.map(function (item) {
        if (index % 2 == 0) {
          result.push(item);
        }
        index++;
      });
      return result;
    },
    myActionTopScores1() {
      var result = [];
      var index = 0;
      vm.leaderboardActions.map(function (item) {
        if (index % 2 == 0) {
          result.push(item);
        }
        index++;
      });
      return result;
    },
    myActionTopScores2() {
      var result = [];
      var index = 0;
      vm.leaderboardActions.map(function (item) {
        if (index % 2 == 1) {
          result.push(item);
        }
        index++;
      });
      return result;
    },
    leaderboardTopGroupLeaders() {
      var result = [];
      if (vm.selectedGroupId) {
        var groups = vm.leaderboardGroups.filter(function (item) {
          return item.GroupID == vm.selectedGroupId;
        });
        if (groups.length > 0) {
          var group = groups[0];
          result = vm.leaderboardLeaders;
          if (vm.groupUserSearchText) {
            vm.groupUserSearchText = vm.groupUserSearchText
              .trim()
              .toLowerCase();
            result = result.filter(function (item) {
              return (
                group.Participances.includes(item.UserID) &&
                item.UserName.toLowerCase().includes(vm.groupUserSearchText)
              );
            });
          } else {
            result = result.filter(function (item) {
              return group.Participances.includes(item.UserID);
            });
          }
        }
      }
      return result;
    },
  },
  watch: {
    //userSearchText(val) {
    //  alert(val);
    //},
    isMaximized() {
      vm.resizeScreen();
    },
    leaderboardLoaded() {
      vm.initLeaderboardTimer();
    },
    //leaderboardActions() {
    //  vm.initLeaderboardTimer();
    //},
    myLeaderboardScore(val) {
      //alert(val);
      bus.$emit("myProfileLeaderboardScore", val);
    },
    settingsLoaded(val) {
      if (val) {
        vm.setupTab();
      }
    },
  },
  beforeCreate() {},
  created() {
    vm = this;
    vm.isMobileView = vm.isMobile();
    $(window).resize(function () {
      vm.isMobileView = vm.isMobile();
    });

    if (vm.$route.params.tid) {
      var tab = vm.$route.params.tid.toLowerCase();
      if (tab == "my-achievements") {
        vm.tab = "myScorecard";
      } else if (tab == "leaders") {
        vm.tab = "users";
      } else if (tab == "leader-groups") {
        vm.tab = "groups";
      }
    }

    //alert(vm.tab);
    //alert(vm.tabCount);
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj) {
      if (obj.client && obj.client.length > 0 && obj.client[0].id) {
        vm.clientId = obj.client[0].id;
      }
      if (obj.eventid) {
        vm.eventId = obj.eventid;
      }
      if (obj.user && obj.user.length > 0 && obj.user[0].id) {
        vm.uid = obj.user[0].id;
        vm.email = obj.user[0].Email;
        vm.firstName = obj.user[0].fname;
        vm.lastName = obj.user[0].lname;
        vm.fullName = obj.user[0].name;
        vm.company = obj.user[0].company;
        vm.designation = obj.user[0].title;
        vm.profilePictureURL = vm.getCDNUrl(obj.user[0].profilepic);
      }
      // common.toggleTopMenu(true);
      // common.toggleLeftMenu(true);
      //$("#btnLoadMenu").click();
      //$("#topmenu").show();
      //$("#leftmenu").hide();

      if (obj.eventcollectionname) {
        vm.event_collectionName = obj.eventcollectionname;
        if (!vm.isModal) {
          db.collection(vm.event_collectionName)
            .doc("Menu")
            .get()
            .then((doc) => {
              var data = doc.data();
              $.each(data.AllMenu, function (key, value) {
                if (value.MenuID == 1028) {
                  if (vm.$store.state.locale == "English") {
                    vm.headerText = value.DisplayLabel;
                  } else if (vm.$store.state.locale == "German") {
                    vm.headerText = value.DisplayLabel_de;
                  } else if (vm.$store.state.locale == "French") {
                    vm.headerText = value.DisplayLabel_fr;
                  } else if (vm.$store.state.locale == "Chinese") {
                    vm.headerText = value.DisplayLabel_zh;
                  } else if (self.$store.state.locale == "Spanish") {
                    vm.headerText = value.DisplayLabel_es;
                  } else {
                    vm.headerText = value.DisplayLabel;
                  }
                }
              });
              $.each(data.LeftMenu, function (key, value) {
                if (value.MenuID == 1028) {
                  if (vm.$store.state.locale == "English") {
                    vm.headerText = value.DisplayLabel;
                  } else if (vm.$store.state.locale == "German") {
                    vm.headerText = value.DisplayLabel_de;
                  } else if (vm.$store.state.locale == "French") {
                    vm.headerText = value.DisplayLabel_fr;
                  } else if (vm.$store.state.locale == "Chinese") {
                    vm.headerText = value.DisplayLabel_zh;
                  } else if (self.$store.state.locale == "Spanish") {
                    vm.headerText = value.DisplayLabel_es;
                  } else {
                    vm.headerText = value.DisplayLabel;
                  }
                }
              });
              let pageTitle = vm.headerText;
              if (obj.eventname != undefined && obj.eventname != "") {
                pageTitle += " - " + obj.eventname;
              }
              $(document).attr("title", pageTitle);
            });
          let pageTitle = vm.headerText;
          if (obj.eventname != undefined && obj.eventname != "") {
            pageTitle += " - " + obj.eventname;
          }
          document.title = pageTitle;
        }
        //usersTab: false,
        //usersTabTop3: false,
        //groupsTab: false,
        //myScorecardTab: false,
        //myTotalScore: false,
        db.collection(vm.event_collectionName)
          .doc("Settings")
          .collection("LeaderBoard")
          .doc("LeaderBoardSettings")
          .get()
          .then((doc) => {
            if (doc.exists) {
              var data = doc.data();
              data.Tabs.forEach(function (item) {
                if (item.TabId == 1) {
                  vm.usersTab = item.IsPublished;
                  if (item.DisplayLabel) {
                    vm.usersTabLabel = item.DisplayLabel;
                  }
                } else if (item.TabId == 2) {
                  vm.groupsTab = item.IsPublished;
                  if (item.DisplayLabel) {
                    vm.groupsTabLabel = item.DisplayLabel;
                  }
                } else if (item.TabId == 3) {
                  vm.myScorecardTab = item.IsPublished;
                  if (item.DisplayLabel) {
                    vm.myScorecardTabLabel = item.DisplayLabel;
                  }
                }
              });
              vm.hasSettings = true;
            }
            vm.settingsLoaded = true;
          })
          .catch(function (error) {
            vm.settingsLoaded = true;
            console.log("Error : " + error);
          });
      }
    }
  },
  mounted() {
    // common.toggleTopMenu(true);
    // common.toggleLeftMenu(true);
    //$("#topmenu").show();
    //$("#leftmenu").show();
    vm.getLeaderboardAction();
    vm.getLeaderboardScore();
    //vm.uapdateLeaderboardData();
    vm.AddEventAnalytics({
      pageName: "/leaderboard",
      action: "click",
      actiontype: "tab",
      actionLabel: "ViewedLeaderboardPage",
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    if (leaderboardTimer) {
      clearInterval(leaderboardTimer);
    }
  },
  methods: {
    onClickHandler(event) {
      vm.AddAnalitics(event, "click");
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              analytics.AddUserAction(
                obj.eventcollectionname,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          analytics.AddUserAction(
            obj.eventcollectionname,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    setupTab() {
      if (
        !vm.usersTabInModal &&
        !vm.groupsTabInModal &&
        !vm.myScorecardTabInModal
      ) {
        vm.myScorecardTabInModal = true;
      }
      if (!vm.hasSettings) {
        vm.usersTab = true;
        vm.groupsTab = true;
        vm.myScorecardTab = true;
      }
      //vm.usersTab = true;
      vm.usersTabTop3 = true;
      //vm.groupsTab = true;
      vm.myScorecardTab = true;
      //vm.myTotalScore = true;

      if (!vm.usersTab && !vm.groupsTab && !vm.myScorecardTab) {
        vm.myScorecardTab = true;
      }
      if (
        !vm.usersTabInModal &&
        !vm.groupsTabInModal &&
        !vm.myScorecardTabInModal
      ) {
        vm.myScorecardTabInModal = true;
      }

      if (vm.usersTab && vm.usersTabInModal) {
        vm.tabCount++;
      }
      if (vm.groupsTab && vm.groupsTabInModal) {
        vm.tabCount++;
      }
      if (vm.myScorecardTab && vm.myScorecardTabInModal) {
        vm.tabCount++;
      }
      if (!vm.tab) {
        if (vm.usersTab && vm.usersTabInModal) {
          vm.tab = "users";
        }
      }
      if (!vm.tab) {
        if (vm.groupsTab && vm.groupsTabInModal) {
          vm.tab = "groups";
        }
      }
      if (!vm.tab) {
        if (vm.myScorecardTab && vm.myScorecardTabInModal) {
          vm.tab = "myScorecard";
        }
      }
    },
    getWidth() {
      this.$nextTick(() => {
        let width = document.getElementById("leftmenu")
          ? document.getElementById("leftmenu").offsetWidth
          : 0;
        $(
          "#leader-board-wrapper-hld"
        ).bodyWith = `width:calc(100% - ${width}px) !important`;
      });
    },
    showGroup(selectedGroupId, selectedGroupName) {
      vm.selectedGroupId = selectedGroupId;
      vm.selectedGroupName = selectedGroupName;
      vm.tab = "groupDetails";
    },
    hideGroup() {
      vm.selectedGroupId = "";
      vm.selectedGroupName = "";
      vm.tab = "groups";
    },
    initLeaderboardTimer() {
      leaderboardTimer = setInterval(function () {
        vm.getLeaderboardScore();
      }, 5000);
    },
    async getLeaderboardScore() {
      //alert("before");
      let result = await vm.getLeaderboardScores(vm.revisionNo);
      //alert("after");
      if (result.status == 0) {
        vm.myActionScores = result.data.MyActionScores;
        //console.log(">>>>>>>>>>>>>>>>" + vm.myActionScores);
        if (vm.revisionNo == 0) {
          //vm.leaderboardLeaderIDs = result.data.LeaderboardLeaderIDs;
          vm.leaderboardLeaders = result.data.LeaderboardLeaders;
          vm.leaderboardBadges = result.data.LeaderboardBadges;
          vm.leaderboardGroups = result.data.LeaderboardGroups;
          //console.log(result.data.LeaderboardLeaders);
        } else {
          result.data.LeaderboardLeaders.map(function (item) {
            var flag = true;
            vm.leaderboardLeaders.map(function (leader) {
              if (leader.UserID == item.UserID) {
                flag = false;

                leader.BadgeCount = item.BadgeCount;
                leader.GroupNames = item.GroupNames;
                leader.IScore = item.IScore;
                leader.IsTopScore = item.IsTopScore;
                leader.NameInitial = item.NameInitial;
                leader.Rank = item.Rank;
                leader.RevisionNo = item.RevisionNo;
                leader.ScorePercent = item.ScorePercent;
                leader.TotalScore = item.TotalScore;
                leader.UserCompany = item.UserCompany;
                leader.UserDesignation = item.UserDesignation;
                leader.UserEmail = item.UserEmail;
                leader.UserFirstName = item.UserFirstName;
                leader.UserID = item.UserID;
                leader.UserImagePath = item.UserImagePath;
                leader.UserLastName = item.UserLastName;
                leader.UserName = item.UserName;
                leader.UserPublisheed = item.UserPublisheed;
                leader.UserVisibility = item.UserVisibility;
              }
            });
            if (flag) {
              vm.leaderboardLeaders.push(item);
            }
            //if (vm.leaderboardLeaderIDs.includes(item.UserID)) {
            //  var leaders = vm.leaderboardLeaders.filter(function (leader) {
            //    return leader.UserID == item.UserID;
            //  });
            //  if (leaders.length > 0) {
            //    leaders[0] = item;
            //  } else {
            //    vm.leaderboardLeaders.push(item);
            //  }
            //}
          });
          //vm.leaderboardLeaders = vm.leaderboardLeaders.filter(function () {
          //  return true;
          //});
          //vm.leaderboardLeaders = vm.leaderboardLeaders.concat(
          //  result.data.LeaderboardLeaders
          //);
          vm.leaderboardBadges = vm.leaderboardBadges.concat(
            result.data.LeaderboardBadges
          );
          //vm.leaderboardGroups = vm.leaderboardGroups.concat(
          //  result.data.LeaderboardGroups
          //);
          result.data.LeaderboardGroups.map(function (item) {
            var flag = true;
            vm.leaderboardGroups.map(function (group) {
              if (group.GroupID == item.GroupID) {
                flag = false;

                group.GroupID = item.GroupID;
                group.GroupImageURL = item.GroupImageURL;
                group.GroupName = item.GroupName;
                group.IsTopScore = item.IsTopScore;
                group.Participances = item.Participances;
                group.Rank = item.Rank;
                group.RevisionNo = item.RevisionNo;
                group.ScorePercent = item.ScorePercent;
                group.TotalScore = item.TotalScore;
              }
            });
            if (flag) {
              vm.leaderboardGroups.push(item);
            }
          });
        }
        //vm.revisionNo = result.data.RevisionNo;

        vm.leaderboardActions.map(function (item) {
          var scores = vm.myActionScores.filter(function (action) {
            return action.Type == item.ActionTypeCode;
          });
          item.Count = 0;
          item.TotalScore = 0;
          if (scores.length > 0) {
            item.Count = scores[0].Count;
            item.TotalScore = scores[0].Score;
          }
        });

        vm.leaderboardActions.sort(function (a, b) {
          let aName = a.DisplayLabel.toLowerCase();
          let bName = b.DisplayLabel.toLowerCase();
          if (aName < bName) {
            return -1;
          }
          if (aName > bName) {
            return 1;
          }
          return 0;
        });
        vm.leaderboardActions.sort(function (a, b) {
          let aName = parseInt(a.TotalScore);
          let bName = parseInt(b.TotalScore);
          if (aName < bName) {
            return 1;
          }
          if (aName > bName) {
            return -1;
          }
          return 0;
        });

        vm.leaderboardLeaders.forEach(function (item) {
          item.NameInitial = common.getInitials(item.UserName);
        });
        vm.leaderboardLoaded = true;
        //var topScore = 0;
        //if (vm.leaderboardLeaders.length > 0) {
        //  topScore = vm.leaderboardLeaders[0].TotalScore;
        //}
        //alert(topScore);
        //vm.leaderboardLeaders.forEach(function (item) {
        //  item.NameInitial = common.getInitials(item.UserName);
        //  //item.ScorePercent = 0;
        //  //if (topScore > 0) {
        //  //  item.ScorePercent = (item.TotalScore / topScore) * 100;
        //  //  if (item.ScorePercent < 100) {
        //  //    item.ScorePercent = item.ScorePercent.toFixed(2);
        //  //  }
        //  //}
        //});
        //topScore = 0;
        //if (vm.leaderboardGroups.length > 0) {
        //  topScore = vm.leaderboardGroups[0].TotalScore;
        //}
        //vm.leaderboardGroups.forEach(function (item) {
        //  item.ScorePercent = 0;
        //  if (topScore > 0) {
        //    item.ScorePercent = (item.TotalScore / topScore) * 100;
        //    if (item.ScorePercent < 100) {
        //      item.ScorePercent = item.ScorePercent.toFixed(2);
        //    }
        //  }
        //});
      }
      //{
      //	data: {
      //		MyActionScores: [],
      //		LeaderboardBadges: [],
      //		LeaderboardLeaders: [],
      //		LeaderboardGroups: [],
      //		RevisionNo: 0,
      //	},
      //	Message: error, StatusCode: 0,
      //	status: 0,
      //}
      //console.log(result);
    },
    async getLeaderboardAction() {
      let result = await vm.getLeaderboardActions();
      if (result.status == 0) {
        vm.leaderboardActions = result.data.LeaderboardActions;

        vm.leaderboardActions.map(function (item) {
          item.DisplayLabel = item.DisplayLabel
            ? item.DisplayLabel
            : item.ActionName;
          item.Count = 0;
          item.TotalScore = 0;
        });
        vm.leaderboardActions = vm.leaderboardActions.filter(function (item) {
          return item.IsPublished;
        });
        //alert(vm.leaderboardActions.length);
      }
      //ActionName: "Session Polls"
      //ActionScore: 10
      //ActionTypeCode: "SPL"
      //IsPublished: true
      //MaxActionScore: 100
      //alert("after");
      //console.log(result);
    },
    async uapdateLeaderboardData(actionTypeCode) {
      actionTypeCode = "EAC";
      let result = await vm.postLeaderboardAction(actionTypeCode);
      if (result.data && result.data.length > 0 && result.data[0].status == 0) {
        vm.showSnackbar("Points collected successfully.", "info", "top");
      } else {
        vm.showSnackbar("Error on collecting point.", "error", "top");
      }
    },
    resizeScreen() {
      if (vm.isMaximized) {
        // common.toggleTopMenu(false);
        // common.toggleLeftMenu(false);
        //$("#topmenu").hide();
        //$("#leftmenu").hide();
        $("#app").addClass("player-full-screen");
      } else {
        // common.toggleTopMenu(true);
        // common.toggleLeftMenu(true);
        //$("#topmenu").show();
        //$("#leftmenu").show();
        $("#app").removeClass("player-full-screen");
      }
      vm.getWidth();
    },
  },
};
</script>
<style lang="scss">
.head-text-wrap {
  width: 20%;
}
.screen-size-wrap {
  width: 20%;
  text-align: right;
}
.mr-50 {
  margin-right: 300px !important;
}
.leader-board-wrapper-hld {
  padding: 15px 15px;
}
.leader-board-wrapper-hld .v-slide-group__content {
  justify-content: center !important;
}
.leader-board-wrapper-hld .v-tabs-slider-wrapper {
  display: none;
}
.tab-wrap {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #f7f7f7;
  box-shadow: inset 0 0px 5px rgb(0 0 0 / 30%);
  border-radius: 6px;
  overflow: hidden;
  height: 40px;
}
.tab-wrap .v-tab {
  height: 100%;
  position: relative;
}
.tab-wrap .v-tab:after {
  position: absolute;
  content: "";
  height: 20px;
  width: 1px;
  background: #cbcbcb;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.tab-wrap .v-tab:last-child:after {
  display: none;
}
.tab-wrap .v-tab.v-tab--active {
  background: #4c4e53;
  color: #fff !important;
}
.tab-wrap .v-tab:after.v-tab--active {
  display: none;
}
.leader-board-rank-list-hld ul {
  margin: 0;
  padding: 0 !important;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.leader-board-rank-list-hld ul li .v-card {
  padding: 20px 0;
  height: 100%;
}
.leader-board-rank-list-hld li {
  width: 18%;
  list-style: none;
  padding: 0 15px;
  margin-top: 12px;
}
.leader-board-rank-list-hld ul li .v-card {
  border-radius: 10px;
}
.leader-board-rank-list-hld ul li.topers-top {
  height: 350px;
}
.top-ranker-image-wrap {
  height: 90px;
  width: 90px;
  margin: 0 auto;
  position: relative;
}
.leader-board-rank-list-hld ul li.topers-top .top-ranker-image-wrap {
  z-index: 2;
  height: 100px;
  width: 100px;
  position: relative;
}
.rank-confetti {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 214px;
  width: 214px;
  transform: translate(-50%, -42%);
  z-index: -1;
}
span.top-rank {
  position: absolute;
  right: 4px;
  bottom: -3px;
  display: inline-block;
  height: 34px;
  width: 34px;
  border: 4px solid #fff;
  border-radius: 50%;
}
.top-rank img {
  height: 100%;
  width: 100%;
}
.top-ranker-image-hld {
  height: 90px;
  width: 90px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.top-ranker-image-hld.no-image {
  border: 2px solid #8c8c8c;
}
li.topers-top .top-ranker-image-hld.no-image span {
  font-size: 38px !important;
}
.top-ranker-image-hld.no-image span {
  font-size: 28px;
  font-weight: 400;
  text-transform: uppercase;
  background: #e6e6e6;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.leader-board-rank-list-hld ul li.topers-top .top-ranker-image-hld {
  height: 100px;
  width: 100px;
}
.top-ranker-image-hld img {
  width: 100%;
  height: 100%;
}
.rank-details {
  text-align: center;
  margin-top: 25px;
}
.progress-wrp {
  width: 238px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
span.progress-value {
  display: inline-block;
  color: #000;
  font-weight: 500;
  margin-left: 10px;
}
.rank-details .v-btn__content {
  font-size: 20px;
  font-weight: 600;
}
.rank-details .participant {
  height: 25px;
  padding: 0 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rank-details p {
  font-size: 16px;
  font-weight: 400;
  color: #70727f;
  height: 24px;
  padding: 0 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-order p {
  height: 40px;
  width: 40px;
  background: #f0f6f7;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin: 0 20px 0 0;
  font-weight: 800;
}
.leader-board-userlist {
  //padding-bottom: 40px;
}
.leader-board-user-search {
  width: 61%;
  //background: #fff;
}
.leader-board-user-search .theme--light.v-input,
.leader-board-user-search .theme--light.v-input input,
.leader-board-user-search .theme--light.v-input textarea {
  height: 48px;
  width: 350px;
}
.leader-board-user-search
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
}
.leader-board-user-search
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  padding: 0 12px 0 35px;
  background: url(../assets/Images/leaderboard/search.svg) no-repeat left center;
  border-bottom: 1px solid #a1a1a1;
  overflow: hidden;
  border-radius: 0 !important;
}
.leaderboard-user-list-top {
  display: flex;
  justify-content: flex-end;
  width: 39%;
}
.leader-board-userlist.group-list .leaderboard-user-list-top {
  display: flex;
  justify-content: flex-end;
  width: 23%;
}
.leaderboard-user-list-top p {
  color: #7e808b;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0 !important;
  font-size: 16px;
}
.list-left {
  width: 61%;
}
.list-right {
  width: 39%;
}
.my-rank-list {
  position: fixed !important;
  bottom: 0;
  //width: 85%;
  //left: 9%;
  width: calc(100% - 200px);
  left: 140px;
  //right: 60px;
  //width: calc(100% - 11rem);
  //left: 8rem;
  //right: 2rem;
  margin: 0 !important;
  box-shadow: 0 0 13px rgb(0 0 0 / 40%) !important;
  transform: scale(1.05);
  border-radius: 10px 10px 0 0 !important;
  z-index: 3;
}
.player-full-screen .my-rank-list {
  width: calc(100% - 120px);
  left: 60px;
}
.list-order label,
.content-my-list label,
.my-points label {
  margin-bottom: 5px;
  font-weight: 600;
  color: #70727f;
  font-size: 14px;
  text-transform: uppercase;
}
.leader-board-userlist .v-card {
  border-radius: 10px;
  overflow: hidden !important;
}
.leader-board-userlist .v-avatar.no-image {
  border: 2px solid #8c8c8c;
}
.leader-board-userlist .v-avatar.no-image span {
  font-size: 32px;
  font-weight: 400;
  text-transform: uppercase;
}
.my-rank-list .v-list {
  border-radius: 10px 10px 0 0 !important;
}
.first-card {
  transform: scale(1.017);
}
.my-achieved-points {
  position: relative;
}
.achieved-points-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.achieved-points-inner .progress-wrp {
  width: 348px;
}
.achieved-points-inner h1 {
  font-weight: 900;
  font-size: 50px;
  color: #000;
  margin-bottom: 6px;
  line-height: 41px;
}
.my-achieved-points {
  overflow: hidden;
  border-radius: 10px !important;
}
.my-achieved-points .v-image__image.v-image__image--cover {
  border-radius: 10px;
}
.point-table {
  border-radius: 10px !important;
}
.point-breakup-table-hld .v-list.v-list--subheader {
  padding: 0 !important;
}
.point-breakup-table-hld .v-list.v-list--subheader:last-child .v-divider {
  display: none;
}
.player-full-screen .v-main {
  padding-top: 0 !important;
}
.player-full-screen .page-wrap-inner {
  justify-content: center;
  width: 100% !important;
}
.player-full-screen #leader-board-wrapper-hld {
  width: 100% !important;
}
.player-full-screen .my-rank-list {
  display: none !important;
}
.tab-wrap .v-tab.v-tab--active:after {
  display: none;
}
.leader-board-wrapper-hld .leader-content {
  background-color: transparent !important;
  background-color: "rgba(255,255,255,0)";
  margin-bottom: 100px;
}
.leader-board-wrapper-hld .leader-content .v-item-group {
  background-color: transparent !important;
}
.leader-board-wrapper-hld .leader-content .leader-board-userlist .v-list {
  background-color: transparent !important;
}
.leader-board-wrapper-hld .leader-content .tab-selected-group {
  justify-content: flex-start;
  white-space: nowrap;
}
.leader-board-wrapper-hld .leader-content .tab-selected-group.v-tab:before {
  background-color: transparent !important;
}
.leader-board-wrapper-hld .leader-content .tab-selected-group h1 {
  white-space: nowrap;
}
.leader-board-blank-page {
  height: calc(100vh - 332px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.leader-board-blank-page h4 {
  max-width: 400px;
  text-align: center;
  margin-bottom: 0 !important;
  margin-top: 15px;
  font-size: 1.5rem;
  font-weight: 400;
  color: #000;
  line-height: 1.9rem;
}
.faq-leaderboard-button {
  font-weight: 600;
  font-size: 1.2rem;
  color: #288aef !important;
  letter-spacing: 1.5px;
}
.expansion-pannel-wrap .v-expansion-panel {
  border: 1px solid #cbcbcb;
  border-radius: 4px;
}
.expansion-pannel-wrap .v-expansion-panel:before {
  display: none;
}
.expansion-pannel-wrap .v-expansion-panel:not(:first-child):after {
  display: none;
}
p.expansion-description {
  font-size: 1.15rem;
  color: #000;
  margin: 0 !important;
  font-weight: 400;
}
.expansion-pannel-wrap .v-expansion-panel-header--active {
  background: #f3f3f3;
  margin-bottom: 15px;
}
h4.expansion-header {
  margin: 0 !important;
  font-size: 1.35rem;
  color: #333;
  font-weight: 600;
}
.expansion-pannel-wrap {
  min-height: 346px;
  max-height: 485px;
  overflow-y: auto;
  padding-right: 4px;
}
h3.dialog-head {
  font-weight: 600;
  font-size: 1.85rem;
  color: #1b1b1b;
}
.topers-top .v-card {
  padding-top: 20px !important;
}
@media only screen and (min-width: 1367px) and (max-width: 1600px) {
  .leader-board-rank-list-hld li {
    width: 25%;
  }
}
@media only screen and (max-width: 1366px),
  screen and (min-height: 601px) and (max-height: 768px) {
  .leader-board-rank-list-hld li {
    width: 25%;
  }
}

/* ============================================================
   Leaderboard page chrome — match Attendee page structure:
   - Use the configured Figma background image
   - Dark backdrop overlay matching Saudi pages (Figma node 36768:2066)
   - Body-content style centered container at max-width 1400px
   ============================================================ */
#leader-board-wrapper-hld.leader-board-wrapper-hld {
  background-color: transparent !important;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT_C1649103310659E1777275891706%2FBranding%2Fleaderboard-bg.jpg?alt=media&token=5c2aace9-8a45-42cd-b256-89ddba9ae3cc") !important;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  background-attachment: fixed;
  position: relative;
  min-height: calc(100vh - 90px);
  padding: 30px 20px;
}
/* Dark backdrop overlay — Figma: rgba(0,0,0,0.3) + blur(5px) */
#leader-board-wrapper-hld.leader-board-wrapper-hld::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  pointer-events: none;
  z-index: 0;
}
/* Lift the section above the overlay so content stays interactive */
#leader-board-wrapper-hld.leader-board-wrapper-hld > section#sectionId {
  position: relative;
  z-index: 1;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}
/* Page title color flips to white over the dark overlay (matches
   Attendee page on Saudi backgrounds). The template carries an inline
   style="color: #333" so the override needs !important. */
#leader-board-wrapper-hld.leader-board-wrapper-hld .page-head.head-text-wrap,
#leader-board-wrapper-hld.leader-board-wrapper-hld
  .page-head.head-text-wrap[style] {
  color: #ffffff !important;
  font-family: "Inter", sans-serif !important;
  font-size: 40px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  text-transform: uppercase !important;
}

/* Header row — Figma puts title left, segmented tabs center,
   "Leaderboard FAQ" link right. */
#leader-board-wrapper-hld .leader-content > .v-tabs-bar > .page-head-text,
#leader-board-wrapper-hld .leader-content .page-head-text {
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 16px;
}

/* Neutralize the legacy gray rounded-rect on .tab-wrap so the Figma
   pills inside can stand on their own. */
#leader-board-wrapper-hld .tab-wrap {
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  overflow: visible !important;
  height: auto !important;
  gap: 6px;
}
#leader-board-wrapper-hld .tab-wrap .v-tab {
  height: auto !important;
}
#leader-board-wrapper-hld .tab-wrap .v-tab:after {
  display: none !important;
}
#leader-board-wrapper-hld .tab-wrap .v-tab.v-tab--active {
  background: #ffffff !important;
  color: #000000 !important;
}

/* Restore + restyle "Leaderboard FAQ" link to the Figma top-right
   slot — 20px message-question icon + white 16px Inter label. */
#leader-board-wrapper-hld .screen-size-wrap {
  display: flex !important;
  align-items: center;
}
#leader-board-wrapper-hld .faq-leaderboard-button {
  display: inline-flex !important;
  align-items: center;
  gap: 7px;
  color: #ffffff !important;
  font-family: "Inter", sans-serif !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
  text-decoration: none !important;
  white-space: nowrap;
}
#leader-board-wrapper-hld .faq-leaderboard-button::before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url("../assets/Images/leaderboard/message-question.svg")
    center/contain no-repeat;
  flex-shrink: 0;
}
#leader-board-wrapper-hld .faq-leaderboard-button .lea_faq {
  color: #ffffff !important;
}

/* ============================================================
   Figma alignment — node 36768:1283
   Pure visual overrides; template / data / handlers untouched.
   ============================================================ */

/* Tab pills row (Participants / My Achievements) — Figma white pill
   active + dark glass inactive */
#leader-board-wrapper-hld .leader-content .v-tabs-bar {
  background: transparent !important;
}
#leader-board-wrapper-hld .leader-content .v-tab {
  background: rgba(0, 0, 0, 0.5) !important;
  -webkit-backdrop-filter: blur(7px);
  backdrop-filter: blur(7px);
  color: #ffffff !important;
  border-radius: 46px !important;
  padding: 8px 19px !important;
  margin-right: 6px !important;
  text-transform: none !important;
  font-family: "Inter", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  min-width: 0 !important;
  height: auto !important;
  opacity: 1 !important;
}
#leader-board-wrapper-hld .leader-content .v-tab.v-tab--active {
  background: #ffffff !important;
  color: #000000 !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}
#leader-board-wrapper-hld .leader-content .v-tabs-slider,
#leader-board-wrapper-hld .leader-content .v-tabs-slider-wrapper {
  display: none !important;
}

/* Top-3 podium cards — Figma white rounded-14 with soft drop shadow */
#leader-board-wrapper-hld .leader-board-rank-list-hld ul {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 16px;
  padding: 0;
  list-style: none;
  width: 100%;
  max-width: 830px;
  margin: 0 auto 24px;
}
#leader-board-wrapper-hld .leader-board-rank-list-hld ul > li {
  width: 266px !important;
  list-style: none;
}
#leader-board-wrapper-hld .leader-board-rank-list-hld ul > li .v-card {
  background: #ffffff !important;
  border-radius: 14px !important;
  box-shadow: 0 3px 1.5px rgba(0, 0, 0, 0.12) !important;
  padding: 30px !important;
  height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
#leader-board-wrapper-hld
  .leader-board-rank-list-hld
  ul
  > li.topers-top
  .v-card {
  height: 326px;
  border: 3px solid #213fd2 !important;
}

/* Avatar inside top-3 podium */
#leader-board-wrapper-hld .top-ranker-image-wrap {
  position: relative;
  display: flex;
  justify-content: center;
}
#leader-board-wrapper-hld .top-ranker-image-hld {
  width: 80px;
  height: 80px;
  border-radius: 999px;
  overflow: hidden;
  background: #e9eef3;
  position: relative;
  z-index: 1;
}
#leader-board-wrapper-hld .topers-top .top-ranker-image-hld {
  width: 100px;
  height: 100px;
}
#leader-board-wrapper-hld .top-ranker-image-hld img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
#leader-board-wrapper-hld .top-rank {
  position: absolute;
  top: -16px;
  right: 50%;
  transform: translateX(50%) translateY(-30%);
  z-index: 2;
  pointer-events: none;
}
#leader-board-wrapper-hld .top-rank img {
  width: 134px;
  height: auto;
}
#leader-board-wrapper-hld .rank-confetti {
  position: absolute;
  top: -40px;
  left: 0;
  right: 0;
  z-index: 0;
  pointer-events: none;
}
#leader-board-wrapper-hld .rank-confetti img {
  width: 100%;
}
#leader-board-wrapper-hld .rank-details {
  text-align: center;
  margin-top: 14px;
  width: 100%;
}
#leader-board-wrapper-hld .rank-details .participant {
  font-family: "Inter", sans-serif !important;
  font-size: 20px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  color: #1a3747 !important;
  margin: 0 0 4px !important;
}
#leader-board-wrapper-hld .rank-details p {
  font-family: "Inter", sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  color: #1a3747 !important;
  margin: 0 !important;
}

/* Score pill — Figma dark rounded-66 white text */
#leader-board-wrapper-hld .list-right .v-btn {
  background-color: #fff !important;
  font-size: 18px !important;
}

#leader-board-wrapper-hld .v-list-item__title {
  font-size: 18px !important;
  color: #000 !important;
}
#leader-board-wrapper-hld .rank-details .v-btn,
#leader-board-wrapper-hld
  .leader-board-userlist
  .v-card
  .v-btn:not(.v-btn--icon) {
  background: #26282b !important;
  color: #ffffff !important;
  border-radius: 66px !important;
  padding: 16px 22px !important;
  height: auto !important;
  min-width: 0 !important;
  text-transform: none !important;
  font-family: "Inter", sans-serif !important;
  font-size: 20px !important;
  font-weight: 500 !important;
  line-height: 16px !important;
  box-shadow: none !important;
  letter-spacing: 0 !important;
}
#leader-board-wrapper-hld .rank-details .v-btn b {
  font-weight: 500 !important;
  color: #ffffff !important;
}

/* Search field — Figma dark glass 8px radius, white border */
#leader-board-wrapper-hld
  .leader-board-user-search
  .v-text-field.v-text-field--solo
  .v-input__control
  > .v-input__slot {
  background: rgba(0, 0, 0, 0.5) !important;
  border: 1px solid #ffffff !important;
  border-radius: 8px !important;
  -webkit-backdrop-filter: blur(17px);
  backdrop-filter: blur(17px);
  box-shadow: none !important;
  padding-left: 14px !important;
  min-height: 44px !important;
  max-width: 390px;
}
#leader-board-wrapper-hld .leader-board-user-search .v-label,
#leader-board-wrapper-hld .leader-board-user-search input {
  color: #ffffff !important;
  font-family: "Inter", sans-serif !important;
  font-size: 15px !important;
}
#leader-board-wrapper-hld .leader-board-user-search .v-label {
  opacity: 0.5;
}

/* "Points" / "Points Earned" label — Figma white uppercase 16/500 */
#leader-board-wrapper-hld .leaderboard-user-list-top p {
  color: #ffffff !important;
  font-family: "Inter", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  text-transform: uppercase !important;
  margin: 0 !important;
}

/* Leaderboard list rows — white rounded-14 with soft shadow */
#leader-board-wrapper-hld .leader-board-userlist .v-card {
  background: #ffffff !important;
  border-radius: 14px !important;
  box-shadow: 0 3px 1.5px rgba(0, 0, 0, 0.12) !important;
  margin: 0 0 5px !important;
}
#leader-board-wrapper-hld .leader-board-userlist .v-card > .v-list {
  background: transparent !important;
  padding: 0 !important;
}
#leader-board-wrapper-hld .leader-board-userlist .v-card .v-list-item {
  padding: 27px 30px !important;
  min-height: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}
#leader-board-wrapper-hld .leader-board-userlist .list-left {
  gap: 30px;
}
/* Gradient rank circle (Figma 50px pinkish gradient) */
#leader-board-wrapper-hld .leader-board-userlist .list-order {
  width: 50px;
  height: 50px;
  border-radius: 999px;
  background-image: linear-gradient(-45deg, #ebd5fb 0%, #fffafc 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
#leader-board-wrapper-hld .leader-board-userlist .list-order p {
  margin: 0 !important;
  font-family: "Inter", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #000000 !important;
  line-height: 16px !important;
}
/* List item avatar */
#leader-board-wrapper-hld .leader-board-userlist .v-list-item__avatar {
  width: 60px !important;
  height: 60px !important;
  min-width: 60px !important;
  border-radius: 999px !important;
}
#leader-board-wrapper-hld .leader-board-userlist .v-list-item__avatar.no-image,
#leader-board-wrapper-hld
  .leader-board-userlist
  .v-list-item__avatar.figma-default-avatar {
  background: #e9eef3 !important;
}
#leader-board-wrapper-hld .leader-board-userlist .v-list-item-content,
#leader-board-wrapper-hld .leader-board-userlist .v-list-item__content {
  padding: 0 !important;
}
#leader-board-wrapper-hld .leader-board-userlist .v-list-item__title {
  font-family: "Inter", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 20px !important;
  color: #1a3747 !important;
}
#leader-board-wrapper-hld .leader-board-userlist .v-list-item__subtitle p {
  font-family: "Inter", sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  color: #1a3747 !important;
  margin: 0 !important;
}

/* The smaller list pill (TotalScore) keeps the Figma dark style above */
#leader-board-wrapper-hld .lb-points-cta {
  background: #26282b !important;
  color: #ffffff !important;
  border-radius: 66px !important;
}

/* The FAQ dialog activator wrapper stays visible (re-shown above),
   but the dialog container itself shouldn't claim layout. */
#leader-board-wrapper-hld .v-dialog__container {
  display: inline !important;
}

/* Final Figma pass for node 36768 screenshots. Visual overrides only. */
#leader-board-wrapper-hld .leader-content {
  margin-bottom: 40px !important;
}
#leader-board-wrapper-hld .leader-content > .v-tabs-bar {
  height: auto !important;
  margin: 0 0 42px !important;
}
#leader-board-wrapper-hld .leader-content .page-head-text {
  padding: 0 !important;
  margin: 0 !important;
}
#leader-board-wrapper-hld .head-text-wrap {
  flex: 0 0 266px !important;
  width: 266px !important;
  max-width: 266px !important;
}
#leader-board-wrapper-hld .tab-wrap {
  flex: 0 0 auto !important;
}
#leader-board-wrapper-hld .screen-size-wrap {
  flex: 0 0 266px !important;
  width: 266px !important;
  max-width: 266px !important;
  justify-content: flex-end !important;
  text-align: right !important;
}
#leader-board-wrapper-hld .leader-board-rank-list-hld {
  width: 100%;
}
#leader-board-wrapper-hld .leader-board-rank-list-hld ul {
  gap: 16px !important;
  max-width: 830px !important;
  margin-bottom: 24px !important;
}
#leader-board-wrapper-hld .leader-board-rank-list-hld ul > li {
  width: 266px !important;
  padding: 0 !important;
  margin: 0 !important;
  height: auto !important;
}
#leader-board-wrapper-hld .leader-board-rank-list-hld ul > li .v-card {
  width: 266px !important;
  min-height: 0 !important;
  height: 280px !important;
  padding: 30px !important;
}
#leader-board-wrapper-hld
  .leader-board-rank-list-hld
  ul
  > li.topers-top
  .v-card {
  height: 326px !important;
  padding: 30px !important;
}
// #leader-board-wrapper-hld
//   .leader-board-rank-list-hld
//   ul
//   > li:last-child
//   .v-card {
//   height: 260px !important;
// }
#leader-board-wrapper-hld .top-ranker-image-wrap {
  width: 100px !important;
  height: 100px !important;
  margin: 0 auto !important;
  align-items: center !important;
}
#leader-board-wrapper-hld .top-ranker-image-hld {
  width: 80px !important;
  height: 80px !important;
}
#leader-board-wrapper-hld .topers-top .top-ranker-image-hld {
  width: 100px !important;
  height: 100px !important;
}
#leader-board-wrapper-hld span.top-rank,
#leader-board-wrapper-hld .top-rank {
  position: absolute !important;
  right: 4px !important;
  bottom: 4px !important;
  top: auto !important;
  width: 34px !important;
  height: 34px !important;
  transform: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 4px solid #ffffff !important;
  border-radius: 50% !important;
  overflow: hidden !important;
  z-index: 3 !important;
}
#leader-board-wrapper-hld .top-rank img {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
}
#leader-board-wrapper-hld .rank-confetti {
  top: -30px !important;
  left: 50% !important;
  right: auto !important;
  width: 204px !important;
  height: 150px !important;
  transform: translateX(-50%) !important;
  overflow: hidden !important;
}
#leader-board-wrapper-hld .rank-confetti img {
  width: 204px !important;
  height: 150px !important;
  object-fit: contain !important;
}
#leader-board-wrapper-hld .rank-details {
  margin-top: 16px !important;
}
#leader-board-wrapper-hld .rank-details .participant {
  height: auto !important;
  padding: 0 !important;
  font-size: 20px !important;
}
#leader-board-wrapper-hld .rank-details p {
  height: auto !important;
  padding: 0 !important;
}
#leader-board-wrapper-hld .rank-details .v-btn {
  min-width: 161px !important;
  min-height: 48px !important;
  padding: 16px 22px !important;
  margin-top: 20px !important;
}
#leader-board-wrapper-hld .leader-board-userlist {
  max-width: 1170px;
  margin: 0 auto;
}
#leader-board-wrapper-hld .leader-board-userlist > .v-list {
  width: 100%;
  padding: 0 !important;
  margin-bottom: 12px !important;
}
#leader-board-wrapper-hld .leader-board-userlist > .v-list .v-list-item {
  padding: 0 !important;
  min-height: 44px !important;
}
#leader-board-wrapper-hld .leader-board-user-search {
  width: 399px !important;
  max-width: 100%;
}
#leader-board-wrapper-hld
  .leader-board-user-search
  .v-text-field.v-text-field--solo
  .v-input__control
  > .v-input__slot {
  width: 399px !important;
  max-width: 100% !important;
  min-height: 40px !important;
  height: 40px !important;
  background: rgba(0, 0, 0, 0.5) url("../assets/Images/leaderboard/search.svg")
    no-repeat left 14px center / 16px !important;
  padding: 0 14px 0 42px !important;
}
#leader-board-wrapper-hld .leader-board-user-search .v-input,
#leader-board-wrapper-hld .leader-board-user-search .v-input__control {
  width: 399px !important;
  max-width: 100% !important;
  min-height: 40px !important;
}
#leader-board-wrapper-hld .leader-board-user-search .v-text-field__details {
  display: none !important;
}
#leader-board-wrapper-hld .leaderboard-user-list-top {
  width: auto !important;
  margin-left: auto !important;
}
#leader-board-wrapper-hld .leader-board-userlist .v-card {
  width: 100% !important;
  min-height: 88px !important;
  margin: 0 0 5px !important;
}
#leader-board-wrapper-hld .leader-board-userlist .v-card .v-list-item {
  min-height: 88px !important;
  padding: 19px 30px !important;
}
#leader-board-wrapper-hld .leader-board-userlist .list-left {
  width: auto !important;
  flex: 1 1 auto !important;
  min-width: 0 !important;
  gap: 22px !important;
}
#leader-board-wrapper-hld .leader-board-userlist .list-right {
  width: auto !important;
  flex: 0 0 auto !important;
}
#leader-board-wrapper-hld .leader-board-userlist .list-order {
  width: 50px !important;
  height: 50px !important;
  flex: 0 0 50px !important;
}
#leader-board-wrapper-hld .leader-board-userlist .list-order p {
  width: 50px !important;
  height: 50px !important;
  background: transparent !important;
  margin: 0 !important;
}
#leader-board-wrapper-hld .leader-board-userlist .v-list-item__avatar {
  width: 50px !important;
  height: 50px !important;
  min-width: 50px !important;
}
#leader-board-wrapper-hld .leader-board-userlist .v-list-item__avatar .v-image {
  width: 50px !important;
  height: 50px !important;
}
#leader-board-wrapper-hld .leader-board-userlist .v-list-item__title {
  max-width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#leader-board-wrapper-hld .leader-board-userlist .v-list-item__subtitle {
  max-width: 360px;
}
#leader-board-wrapper-hld .leader-board-userlist .v-list-item__subtitle p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#leader-board-wrapper-hld
  .leader-board-userlist
  .v-card
  .v-btn:not(.v-btn--icon),
#leader-board-wrapper-hld .list-right .v-btn {
  min-width: 88px !important;
  min-height: 48px !important;
  padding: 16px 22px !important;
}

@media only screen and (max-width: 1199px) {
  #leader-board-wrapper-hld.leader-board-wrapper-hld {
    padding: 28px 24px !important;
  }
  #leader-board-wrapper-hld .head-text-wrap,
  #leader-board-wrapper-hld .screen-size-wrap {
    flex-basis: 220px !important;
    width: 220px !important;
    max-width: 220px !important;
  }
  #leader-board-wrapper-hld .leader-board-rank-list-hld ul {
    max-width: 760px !important;
  }
  #leader-board-wrapper-hld .leader-board-rank-list-hld ul > li,
  #leader-board-wrapper-hld .leader-board-rank-list-hld ul > li .v-card {
    width: 238px !important;
  }
}

@media only screen and (max-width: 991px) {
  #leader-board-wrapper-hld .leader-content > .v-tabs-bar {
    margin-bottom: 28px !important;
  }
  // #leader-board-wrapper-hld .leader-content .page-head-text {
  //   flex-wrap: wrap !important;
  //   justify-content: flex-start !important;
  // }
  #leader-board-wrapper-hld .head-text-wrap {
    flex: 1 1 100% !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  #leader-board-wrapper-hld .tab-wrap {
    order: 2;
  }
  #leader-board-wrapper-hld .screen-size-wrap {
    order: 3;
    flex: 1 1 auto !important;
    width: auto !important;
    max-width: none !important;
  }
  #leader-board-wrapper-hld .leader-board-rank-list-hld ul {
    align-items: stretch !important;
    gap: 12px !important;
    max-width: 100% !important;
  }
  #leader-board-wrapper-hld .leader-board-rank-list-hld ul > li,
  #leader-board-wrapper-hld .leader-board-rank-list-hld ul > li .v-card {
    width: calc((100vw - 96px) / 3) !important;
  }
  #leader-board-wrapper-hld .leader-board-rank-list-hld ul > li .v-card,
  #leader-board-wrapper-hld
    .leader-board-rank-list-hld
    ul
    > li.topers-top
    .v-card,
  #leader-board-wrapper-hld
    .leader-board-rank-list-hld
    ul
    > li:last-child
    .v-card {
    height: 280px !important;
    padding: 24px 16px !important;
  }
  #leader-board-wrapper-hld .rank-details .participant {
    font-size: 17px !important;
  }
  #leader-board-wrapper-hld .rank-details .v-btn {
    min-width: 132px !important;
    font-size: 16px !important;
  }
}

@media only screen and (max-width: 767px) {
  #leader-board-wrapper-hld.leader-board-wrapper-hld {
    padding: 24px 16px !important;
    background-attachment: scroll;
  }
  #leader-board-wrapper-hld.leader-board-wrapper-hld .page-head.head-text-wrap,
  #leader-board-wrapper-hld.leader-board-wrapper-hld
    .page-head.head-text-wrap[style] {
    font-size: 32px !important;
    line-height: 36px !important;
  }
  #leader-board-wrapper-hld .tab-wrap {
    width: 100%;
    overflow-x: auto !important;
    justify-content: flex-start !important;
    padding-bottom: 2px;
  }
  #leader-board-wrapper-hld .screen-size-wrap {
    width: 100% !important;
    flex-basis: 100% !important;
    justify-content: flex-start !important;
  }
  #leader-board-wrapper-hld .leader-board-rank-list-hld ul {
    overflow-x: auto;
    justify-content: flex-start !important;
    padding-bottom: 6px !important;
  }
  #leader-board-wrapper-hld .leader-board-rank-list-hld ul > li,
  #leader-board-wrapper-hld .leader-board-rank-list-hld ul > li .v-card {
    width: 246px !important;
    flex: 0 0 246px !important;
  }
  #leader-board-wrapper-hld .leader-board-userlist > .v-list .v-list-item {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 10px;
  }
  #leader-board-wrapper-hld .leader-board-user-search,
  #leader-board-wrapper-hld .leader-board-user-search .v-input,
  #leader-board-wrapper-hld .leader-board-user-search .v-input__control {
    width: 100% !important;
  }
  #leader-board-wrapper-hld
    .leader-board-user-search
    .v-text-field.v-text-field--solo
    .v-input__control
    > .v-input__slot {
    width: 100% !important;
  }
  #leader-board-wrapper-hld .leaderboard-user-list-top {
    align-self: flex-end;
  }
  #leader-board-wrapper-hld .leader-board-userlist .v-card .v-list-item {
    padding: 16px !important;
  }
  #leader-board-wrapper-hld .leader-board-userlist .list-left {
    gap: 12px !important;
  }
  #leader-board-wrapper-hld .leader-board-userlist .v-list-item__title,
  #leader-board-wrapper-hld .leader-board-userlist .v-list-item__subtitle {
    max-width: 160px;
  }
}

/* ============================================================
   My Achievements tab — UX polish
   Pure CSS; template/data/logic untouched.
   ============================================================ */

/* Hero "Total Points" card */
#leader-board-wrapper-hld .my-achieved-points {
  position: relative;
  overflow: hidden;
  border-radius: 16px !important;
  background: linear-gradient(135deg, #f4f6ff 0%, #e9ecff 60%, #ffe9f5 100%);
  min-height: 180px;
  margin-bottom: 20px !important;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
}
#leader-board-wrapper-hld .my-achieved-points .v-image {
  opacity: 0.45;
}
#leader-board-wrapper-hld .achieved-points-inner {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  transform: none !important;
  top: 0 !important;
  left: 0 !important;
}
#leader-board-wrapper-hld .achieved-points-inner h1 {
  font-family: "Inter", sans-serif !important;
  font-size: 64px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  color: #1a3747 !important;
  margin: 0 0 4px !important;
  letter-spacing: -0.5px;
}
#leader-board-wrapper-hld .achieved-points-inner h4 {
  font-family: "Inter", sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  letter-spacing: 2px !important;
  color: #1a3747 !important;
  opacity: 0.7;
  margin: 0 !important;
  text-transform: uppercase;
}

/* Mobile total chip */
#leader-board-wrapper-hld .total-point-display {
  background: #26282b !important;
  color: #ffffff !important;
  border-radius: 14px !important;
  padding: 12px 18px !important;
  margin: 0 0 16px !important;
  align-items: center !important;
  justify-content: center !important;
}
#leader-board-wrapper-hld .total-point-display h3 {
  font-family: "Inter", sans-serif !important;
  color: #ffffff !important;
  margin: 0 !important;
  font-size: 22px !important;
  font-weight: 600 !important;
}

/* Header row — dark translucent pill so labels stay readable
   regardless of the background image behind. */
#leader-board-wrapper-hld .point-breakup-table-hld > .row,
#leader-board-wrapper-hld .point-breakup-table-hld .row {
  margin: 0 !important;
}
#leader-board-wrapper-hld .point-breakup-table-hld .col,
#leader-board-wrapper-hld .point-breakup-table-hld [class*="col-"] {
  padding: 0 !important;
}
#leader-board-wrapper-hld
  .point-breakup-table-hld
  .col
  > .v-list:first-child:not(.point-table .v-list),
#leader-board-wrapper-hld
  .point-breakup-table-hld
  [class*="col-"]
  > .v-list:first-child:not(.point-table .v-list) {
  background: #fff !important;
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  border-radius: 10px !important;
  padding: 0 !important;
  margin: 0 0 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
#leader-board-wrapper-hld
  .point-breakup-table-hld
  .col
  > .v-list:first-child
  .v-list-item {
  min-height: 48px !important;
  padding: 0 24px !important;
  background: transparent !important;
}
/* Match Vuetify's v-col element which renders as both .col and .v-col,
   and use .theme--light prefix to beat Vuetify's dark-text default
   on v-list-item__title. */
#leader-board-wrapper-hld
  .point-breakup-table-hld
  .col
  > .v-list:first-child
  .v-list-item__title,
#leader-board-wrapper-hld
  .point-breakup-table-hld
  .v-col
  > .v-list:first-child
  .v-list-item__title,
#leader-board-wrapper-hld
  .point-breakup-table-hld
  .col
  > .v-list:first-child
  .theme--light.v-list-item
  .v-list-item__title,
#leader-board-wrapper-hld
  .point-breakup-table-hld
  .v-col
  > .v-list:first-child
  .theme--light.v-list-item
  .v-list-item__title {
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  letter-spacing: 1.2px !important;
  text-transform: uppercase !important;
  color: #ffffff !important;
  line-height: 16px !important;
}

/* Table body — white rounded card with soft shadow */
#leader-board-wrapper-hld .point-table.v-card {
  background: #ffffff !important;
  border-radius: 14px !important;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08) !important;
  overflow: hidden !important;
  margin: 0 !important;
}
#leader-board-wrapper-hld .point-table.v-card > .v-list {
  background: transparent !important;
  padding: 0 !important;
}
#leader-board-wrapper-hld .point-table .v-list-item {
  min-height: 56px !important;
  padding: 0 24px !important;
  transition: background-color 0.15s ease;
}
/* Zebra rows for readability */
#leader-board-wrapper-hld .point-table > .v-list:nth-child(even) .v-list-item {
  background: #fafbfd !important;
}
#leader-board-wrapper-hld .point-table .v-list-item:hover {
  background: #f1f4f9 !important;
}
#leader-board-wrapper-hld .point-table .v-list-item__title {
  font-family: "Inter", sans-serif !important;
  font-size: 15px !important;
  font-weight: 400 !important;
  line-height: 22px !important;
  color: #1a3747 !important;
}
#leader-board-wrapper-hld .point-table .v-list-item__title b {
  font-weight: 500 !important;
  color: #1a3747 !important;
}
/* Right-aligned numeric columns — tabular numerics */
#leader-board-wrapper-hld
  .point-table
  .v-list-item__content[style*="text-align: right"]
  .v-list-item__title {
  font-variant-numeric: tabular-nums;
}
/* Emphasize the "Points Earned" column (last right-aligned cell) */
#leader-board-wrapper-hld
  .point-table
  .v-list-item
  > .v-list-item__content:last-child
  .v-list-item__title
  b {
  font-weight: 600 !important;
  font-size: 16px !important;
  color: #0e7c5a !important;
}

/* Soft divider between rows */
#leader-board-wrapper-hld .point-table .v-divider.m-0 {
  border-color: rgba(26, 55, 71, 0.08) !important;
  margin: 0 !important;
}
#leader-board-wrapper-hld .point-table .v-list:last-child .v-divider.m-0 {
  display: none !important;
}

/* All table rows render in full — no internal height cap, so every
   row in leaderboardActions is visible. The page itself scrolls
   naturally; bottom clearance below reserves room for the fixed
   "My Rank" bar so the last rows aren't covered. */
#leader-board-wrapper-hld .leader-content .v-window__container,
#leader-board-wrapper-hld .leader-content .v-tabs-items {
  padding-bottom: 96px;
}

/* "My Rank" floating bar — tighten height and reserve space on the
   right so it doesn't slide under the 220px Engage @Event widget. */
#leader-board-wrapper-hld .my-rank-list {
  width: calc(100% - 380px) !important;
  left: 140px !important;
  transform: none !important;
  border-radius: 12px 12px 0 0 !important;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.25) !important;
}
#leader-board-wrapper-hld .my-rank-list > .v-list {
  padding: 10px 16px !important;
  min-height: 0 !important;
  border-radius: 10px 10px 0 0 !important;
  background-color: #26282b !important;
}
#leader-board-wrapper-hld .my-rank-list .v-list-item {
  min-height: 0 !important;
  padding: 0 8px !important;
}
#leader-board-wrapper-hld .my-rank-list .list-order p,
#leader-board-wrapper-hld .my-rank-list .my-points h3 {
  margin: 0 !important;
  line-height: 1.2 !important;
  font-size: 18px !important;
}
#leader-board-wrapper-hld .my-rank-list .list-order label,
#leader-board-wrapper-hld .my-rank-list .my-points label,
#leader-board-wrapper-hld .my-rank-list .content-my-list label {
  font-size: 10px !important;
  letter-spacing: 1px !important;
  margin: 0 0 4px !important;
  line-height: 1.2 !important;
  color: rgba(255, 255, 255, 0.65) !important;
  display: block;
}

/* Fix overlap in the floating "My Rank" bar: kill the mt-5 push-down on the
   avatar (legacy from the tall layout), shrink everything to fit the now-
   compact dark bar, and align all three columns to a shared baseline. */
#leader-board-wrapper-hld .my-rank-list .list-left {
  gap: 14px;
  min-width: 0;
}
#leader-board-wrapper-hld .my-rank-list .list-order {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 4px;
}
#leader-board-wrapper-hld .my-rank-list .list-order p {
  height: 36px !important;
  width: 36px !important;
  margin: 0 !important;
  font-size: 14px !important;
  font-weight: 700;
}
#leader-board-wrapper-hld .my-rank-list .v-list-item__avatar,
#leader-board-wrapper-hld .my-rank-list .v-avatar {
  margin: 0 !important;
  height: 38px !important;
  width: 38px !important;
  min-width: 38px !important;
  align-self: center !important;
}
#leader-board-wrapper-hld .my-rank-list .v-list-item__avatar.no-image,
#leader-board-wrapper-hld .my-rank-list .v-avatar.no-image {
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
}
#leader-board-wrapper-hld .my-rank-list .v-avatar span {
  font-size: 13px !important;
  font-weight: 600;
}
#leader-board-wrapper-hld .my-rank-list .content-my-list {
  margin-left: 4px !important;
  padding: 0 !important;
  min-width: 0;
  align-self: center !important;
}
#leader-board-wrapper-hld .my-rank-list .v-list-item__title {
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 1.25 !important;
  color: #ffffff !important;
}
#leader-board-wrapper-hld .my-rank-list .v-list-item__subtitle p {
  font-size: 11px !important;
  color: rgba(255, 255, 255, 0.65) !important;
  margin: 0 !important;
  line-height: 1.2 !important;
}
#leader-board-wrapper-hld .my-rank-list .my-points {
  align-self: center !important;
}
#leader-board-wrapper-hld .my-rank-list .my-points .v-btn {
  height: 32px !important;
  min-width: 80px !important;
}

@media (max-width: 991px) {
  #leader-board-wrapper-hld .my-rank-list {
    width: calc(75% - 32px) !important;
    left: 16px !important;
  }
  .list-right {
    width: 35%;
  }
}

/* Smooth, visible page scrollbar so it's obvious users can scroll to
   reach all activity rows. Targets the leaderboard wrapper and the
   parent v-main / v-application scroll containers. */
html {
  scroll-behavior: smooth;
}
#leader-board-wrapper-hld {
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.55) rgba(255, 255, 255, 0.1);
}
#leader-board-wrapper-hld::-webkit-scrollbar,
.v-application::-webkit-scrollbar,
.v-main::-webkit-scrollbar {
  width: 10px;
}
#leader-board-wrapper-hld::-webkit-scrollbar-track,
.v-application::-webkit-scrollbar-track,
.v-main::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 10px;
}
#leader-board-wrapper-hld::-webkit-scrollbar-thumb,
.v-application::-webkit-scrollbar-thumb,
.v-main::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.45);
  border-radius: 10px;
  transition: background 0.2s ease;
}
#leader-board-wrapper-hld::-webkit-scrollbar-thumb:hover,
.v-application::-webkit-scrollbar-thumb:hover,
.v-main::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.75);
}

/* Responsive — stack cleanly on narrow widths */
@media (max-width: 767px) {
  #leader-board-wrapper-hld .achieved-points-inner h1 {
    font-size: 48px !important;
  }
  #leader-board-wrapper-hld .point-table .v-list-item,
  #leader-board-wrapper-hld
    .point-breakup-table-hld
    .col
    > .v-list:first-child
    .v-list-item {
    padding: 0 16px !important;
  }
}
</style>
